// extracted by mini-css-extract-plugin
export default {"basicPlanCreate":"styles_basicPlanCreate__UOc11","head":"styles_head__QYIyu","actions":"styles_actions__EPuxx","questionContainer":"styles_questionContainer__LyCu2"};